{
  "id": "usr-01",
  "username": "Mánager General",
  "email": "manager@lom.es",
  "roles": ["Director Técnico & Club Manager"],
  "avatar": "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80"
}
